var __extends = this.__extends || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    __.prototype = b.prototype;
    d.prototype = new __();
};
define(["require", "exports", 'app/page/CustomAbstractController', "app/classes/not-translated-service/NotTranslatedService", "lib/temple/locale/LocaleManager", 'lib/gaia/api/Gaia', 'app/data/DataManager', 'app/data/enum/StoryTypes', 'app/data/enum/StoryElementTypes', 'app/util/LocaleUtils'], function (require, exports, CustomAbstractController, NotTranslatedService, LocaleManager, Gaia, DataManager, StoryTypes, StoryElementTypes, LocaleUtils) {
    var AbstractStoryController = (function (_super) {
        __extends(AbstractStoryController, _super);
        function AbstractStoryController() {
            _super.call(this);
        }
        AbstractStoryController.prototype.init = function () {
            _super.prototype.init.call(this);
            this.getStory();
        };
        AbstractStoryController.prototype.onDeeplink = function (event) {
            if (event.routeResult[0].branch !== this.page.getBranch())
                return;
            this.viewModel.story(null);
            this.getStory();
        };
        AbstractStoryController.prototype.getStory = function () {
            var _this = this;
            var storyId = Gaia.api.getParam('id');
            var p = DataManager.getInstance().storyService.getItem(storyId).then(function (response) {
                if (_this.isDestructed === true || response.success === false || response.data[0] === false)
                    return; // last check is backend not finding a story
                var language = LocaleManager.getInstance().getLanguage();
                if (response.data.language !== language) {
                    return NotTranslatedService.getInstance().appendNotFound(language);
                }
                var story = response.data;
                // header is never in the story elements, but is in fact a story element.
                // we manually create the data here and insert it
                var header = {
                    // both story types
                    title: story.title,
                    image: story.image,
                    type: story.type === StoryTypes.PREMIUM ? StoryElementTypes.HEADER_IMAGE_WITH_TITLE : StoryElementTypes.REGULAR_HEADER_IMAGE,
                    number: story.number,
                    // premium
                    subtitle: story.subtitle,
                    // regular
                    author: story.author
                };
                //			if(DEBUG)
                //			{
                //				var imageWithQuote:IStoryElement = {
                //					type: StoryElementTypes.IMAGE_WITH_QUOTE,
                //					image: story.image,
                //					quote: 'Test quote'
                //				};
                //				story.story_elements.unshift(imageWithQuote)
                //			}
                if (story.story_elements) {
                    story.story_elements.unshift(header);
                }
                LocaleUtils.setPageTitle(story.title);
                _this.viewModel.story(story);
            });
            this.showLoader(p);
        };
        AbstractStoryController.prototype.destruct = function () {
            // Put your cleaning here
            // always call this last
            _super.prototype.destruct.call(this);
        };
        return AbstractStoryController;
    })(CustomAbstractController);
    return AbstractStoryController;
});
